import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneVideo, updateVideo } from 'slice/videoSlice';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getUploadUrl } from 'utils/uploadUrl';

const Update = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, oneData } = useSelector((state) => state.video);

    const [videoName, setVideoName] = useState('');
    const [videoFile, setVideoFile] = useState(null);

    useEffect(() => {
        dispatch(getOneVideo(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (oneData) {
            setVideoName(oneData.videoName || '');
        }
    }, [oneData]);

    const handleFileChange = (e) => {
        setVideoFile(e.target.files[0]);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('videoName', videoName);
        if (videoFile) data.append('video', videoFile);

        dispatch(updateVideo({ id, data }));
        toast.success('Video updated successfully!');
        setTimeout(() => navigate('/khajuraho/videos'), 1500);
    };

    const getFileUrl = (file) => {
        if (!file) return '';
        return getUploadUrl(file);
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Update Promotional Video</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="videoName" className="adminlables">Video Name / Title</label>
                        <input 
                            type="text" 
                            id="videoName"
                            value={videoName} 
                            className="form-control" 
                            onChange={(e) => setVideoName(e.target.value)} 
                            required 
                        />
                    </div>
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="videoFile" className="adminlables">Change Video File (Optional)</label>
                        <input 
                            type="file" 
                            id="videoFile"
                            className="form-control filebg" 
                            onChange={handleFileChange} 
                            accept="video/*"
                        />
                        {oneData?.videoPath && (
                            <div className="mt-3">
                                <p className="small text-muted mb-1">Current Video:</p>
                                <video width="200" controls muted className="rounded shadow-sm">
                                    <source src={getFileUrl(oneData.videoPath)} type="video/mp4" />
                                </video>
                            </div>
                        )}
                    </div>
                </div>
                <div className="mt-5 text-right">
                    <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Updating...' : 'Update Video'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Update;
